export const MAX_COMMENT_LENGTH = 370;
